var React = require('react');

function AmInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M264.437 7.77895C233.5 6.32271 71.8999 2.21646 0 33.3643C19.4458 44.8518 40.3041 56.7685 64.7916 69.6851C136.048 36.3477 228.491 24.2914 313.508 19.6519V17.4914C296.977 15.4727 278.727 11.9414 264.437 7.77895Z","fill":"#007397","key":0}),React.createElement("path",{"d":"M337.085 20.8457C273.295 27.2124 160.373 45.7061 96.0291 85.7706C119.425 97.5415 143.889 109.196 168.331 120.085C236.077 62.329 325.687 36.7145 417.004 18.7624V16.6458C393.802 19.3749 358.747 21.0437 337.085 20.8457Z","fill":"#007397","key":1}),React.createElement("path",{"d":"M201.977 134.554C232.839 147.314 264.766 159.05 291.962 166.893C324.731 101.756 383.97 50.1206 493.149 2.80192V0.666504C352.912 39.0123 265.156 66.4872 201.977 134.554Z","fill":"#007397","key":2})]);
}

AmInline.defaultProps = {"width":"494","height":"167","viewBox":"0 0 494 167","fill":"none"};

module.exports = AmInline;

AmInline.default = AmInline;
